import { cn } from "@/lib/utils";
import { formatRemaining, type RemainingInfo, type RemainingKind } from "@/engine/remaining";

export const REMAINING_TONE: Record<RemainingKind, string> = {
  done: "text-muted-foreground",
  upcoming: "text-muted-foreground",
  active: "text-foreground/80",
  overdue: "text-critical",
};

/** Remaining working days pinned outside, to the left of a summary bracket. Renders nothing when done. */
export function RemainingLabel({ info, className, style }: { info: RemainingInfo; className?: string; style?: React.CSSProperties }) {
  if (info.kind === "done") return null;
  return (
    <span
      className={cn("pointer-events-none whitespace-nowrap text-[11px] leading-none font-normal tabular-nums", REMAINING_TONE[info.kind], className)}
      style={style}
    >
      {formatRemaining(info)}
    </span>
  );
}
